import { AppSettingsViewModel } from "../app/@core/models/ac-forms.models";

declare var window: any;

export class SharedEnvironment {

  public get emailValidationRegex(): string {
    return window.config.emailValidationRegex;
  }

  public get config(): AppSettingsViewModel {
    return window.config;
  }

}
